import { includes } from "lodash";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import constants from "./constants";
import CorporateDataDeals from "./CorporateDataDeals";
import operations from "./ducks/operations";

const CorporateDataDealsContainer = (props) => {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/deals", title: "CDT Deals" });
    }, []);

    return <CorporateDataDeals {...props} />;
};

const mapStateToProps = (state) => {
    return {
        auth: state.authReducer,
        deals: state.dealsReducer.deals,
        dealView: includes(["data_entry_unassigned", "data_entry_open"], state.dealsReducer.dealView)
            ? state.dealsReducer.dealView
            : "data_entry_unassigned",
        isLoading: state.utilsReducer.isLoading,
        dealsPage: state.dealsReducer.dealsPage,
        dealsSort: state.dealsReducer.dealsSort,
        dealsFilter: state.dealsReducer.dealsFilter,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        switchDealView: (event, value) => {
            dispatch(operations.switchTab(value));
        },
        setDealsPage: (page) => {
            dispatch(operations.setDealsPage(page));
        },
        setDealsSort: (sort) => {
            dispatch(operations.setDealsSort(sort));
        },
        setDealsFilter: (filter) => {
            dispatch(operations.setDealsFilter(filter));
        },
        resetDealsTab: () => {
            dispatch(operations.resetDealsTab());
        },
        getCorporateDataOpenDeals: (user) => {
            dispatch(operations.getDeals(constants.urls.data_entry_open(user), "data_entry_open"));
        },
        getCorporateDataUnassignedDeals: () => {
            dispatch(operations.getDeals(constants.urls.data_entry_unassigned(), "data_entry_unassigned"));
        },
        handleStartReviewingAsCorporateData: (deal, currentPath) => {
            return dispatch(operations.handleStartReviewingAsCorporateData(deal, currentPath));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CorporateDataDealsContainer);
